import { Box, Flex, Grid, Button, Spinner, Text } from "@chakra-ui/react";
import WidgetWrapper from "../../../components/Widgets/WidgetWrapper";
import { InputComponent } from "../../../components/Widgets/InputComponent";
import { useContext, useEffect, useState } from "react";
import { changeFirebaseAuthPassword } from "../../Login/index.js";
import { UserContext } from "../../../context";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { isGoogleUser } from "../../../functions/isGoogleUser";
import { unlink } from "firebase/auth";
import { useTranslation } from "react-i18next";

const ChangePassword = () => {
  const { t } = useTranslation();

  const [state] = useContext(UserContext);
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [passwordOK, setPasswordOK] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (
      password === repeatPassword &&
      password.length >= 8 &&
      repeatPassword.length >= 8 &&
      oldPassword.length >= 8 &&
      state.user.email
    ) {
      setPasswordOK(true);
    } else {
      setPasswordOK(false);
    }
  }, [password, repeatPassword, oldPassword, state.user.email]);

  return (
    <Grid width={["100%", "100%", "600px"]} gap={5}>
      {state.user && isGoogleUser(state.user) ? (
        <WidgetWrapper
          child={
            <Flex flexDirection={"column"}>
              <Text color={"#292929"} fontWeight={"semibold"}>
                {t("removeGoogleFromAccount")}{" "}
              </Text>
              <Text color={"#292929"}>{t("removeGoogleFromAccountText")}</Text>
              <Box>
                <Button
                  marginTop={"20px"}
                  bg={"#5138EE"}
                  color={"white"}
                  onClick={async () => {
                    await unlink(state.user, "google.com");
                    toast.success(t("removeGoogleFromAccountSuccessPassword"));
                    navigate("updatera-losenord");
                  }}
                >
                  {t("removeGoogleFromAccount")}
                </Button>
              </Box>
            </Flex>
          }
        ></WidgetWrapper>
      ) : (
        <WidgetWrapper
          child={
            <form
              style={{ width: "100%" }}
              onSubmit={async (e) => {
                e.preventDefault(e);
                if (password === oldPassword) {
                  toast.error(t("newPasswordTheSameError"));
                  return;
                }
                setLoading(true);
                const response = await changeFirebaseAuthPassword(
                  state.user.email,
                  oldPassword,
                  password
                );
                if (response.status !== 200) {
                  toast.error(response.error);
                } else {
                  toast.success(response.message);
                  navigate("");
                }
                setLoading(false);
              }}
            >
              <Flex flexDirection={"column"} width={"100%"} gap={4}>
                <InputComponent
                  toolTip={true}
                  toolTipText={t("newPasswordChange")}
                  placeholder={t("newPasswordRequierment")}
                  label={t("newPassword")}
                  setState={setPassword}
                  value={password}
                  type={"password"}
                  showPassword={true}
                />
                <InputComponent
                  toolTip={true}
                  toolTipText={t("repeatNewPasswordTooltip")}
                  placeholder={t("newPasswordRequierment")}
                  label={t("reperatNewPassword")}
                  setState={setRepeatPassword}
                  value={repeatPassword}
                  type={"password"}
                  showPassword={true}
                />
                <InputComponent
                  toolTip={true}
                  toolTipText={t("currentPasswordTooltip")}
                  placeholder={t("currentPassword")}
                  label={t("currentPassword")}
                  setState={setOldPassword}
                  value={oldPassword}
                  type={"password"}
                  showPassword={true}
                />
                <Box>
                  <Button
                    color={"white"}
                    fontWeight={"bold"}
                    isDisabled={!loading && passwordOK ? false : true}
                    bg={"#5138EE"}
                    type="submit"
                  >
                    {loading ? <Spinner /> : t("changePassword")}
                  </Button>
                </Box>
              </Flex>
            </form>
          }
        ></WidgetWrapper>
      )}
    </Grid>
  );
};

export default ChangePassword;
